var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"md-card-tabs",class:[
      { 'flex-column': _vm.flexColumn },
      { 'nav-pills-icons': _vm.navPillsIcons },
      { 'md-card-plain': _vm.plain }
    ]},[_c('md-card-header',{attrs:{"slot":"header-title"},slot:"header-title"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }